import {
  DeleteMarketplaceCompanyInstallationDocument,
  DeleteMarketplaceCompanyInstallationMutation,
  GetMarketplaceCompanyInstallationsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteMarketplaceCompanyInstallation = () => {
  const [mutate] = useMutation(DeleteMarketplaceCompanyInstallationDocument, {
    extractorFn: (data: DeleteMarketplaceCompanyInstallationMutation) =>
      data.marketplaceMutations.deleteMarketplaceCompanyInstallation,
  })

  const deleteMarketplaceCompanyInstallation = (
    integrationId: number,
    companyId: number,
    accessId: number
  ) => {
    return mutate({
      variables: { integrationId, companyId, accessId },
      refetchQueries: [GetMarketplaceCompanyInstallationsDocument],
    })
  }

  return deleteMarketplaceCompanyInstallation
}

export default useDeleteMarketplaceCompanyInstallation
